// kyc update
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize,} from "rn-responsive-styles";


const useStyles = CreateResponsiveStyle(

  {
    container: {
      marginLeft: 40,
      height: 655,
    },
    pdfViewStyle: {
      padding: 0,
      height: 600,
      width: "100%",
  },
    overlayContentStyle: {
      width: "80%",
      height: 600,
      backgroundColor: "white",
      borderRadius: 15,
      alignSelf: "center",
      justifyContent: "center",
      marginVertical: 30
  
  },
    contentTwoStyle:{ width: "100%",marginLeft:30,paddingHorizontal:20 },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    KYCUpd: {
      paddingHorizontal: 20,
    },
    KYCUpd_row2: {
      height: 203,
      marginTop: 20,
      flexDirection: "row",
    },
    KYCUpd_row2_KYCInfo: {
      width: 281,
      borderRadius: 12,
      border: "1px solid #ff6e6e",
    },
    KYCUpd_row2_KYCInfo_fullKYC: {
      height: "50%",
      backgroundImage:
        "linear-gradient(to right, #F8EBEC, #F8EBEC, #fff 94%, rgba(94, 94, 94, 0) 108%)",
      padding: 20,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      justifyContent: "center",
    },
    crownIcon: {
      position: "absolute",
      top: 20,
      right: 20,
      width: 18.3,
      height: 16,
    },
    KYCUpd_row2_KYCInfo_minKYC: {
      height: "50%",
      padding: 20,
      justifyContent: "center",
    },
  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {
    },

    [maxSize(DEVICE_SIZES.MD)]: {
      container: {
        height: "default",
      },
      contentTwoStyle:{
        width:"100%"
      },
      KYCUpd_row2: {
        height: 440,
        flexDirection: "column",
        marginTop: 0,
      },

      KYCUpd_row2_KYCInfo: {
        height: "132px",
        width: "100%",
      },

      KYCUpd_row2_KYCInfo_fullKYC: {
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
      },
     
      KYCUpd_row2_KYCInfo_minKYC: {
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },

      SvcRq_header: {
        flexDirection: "column",
        height: 140,
      },
      KYCUpd_row2: {
        height: 510,
      },

      KYCUpd_row2_KYCInfo: {
        height: 203,
      },

      KYCUpd_row2_KYCInfo_fullKYC: {
        flexDirection: "column",
        alignItems: "default",
      },

      KYCUpd_row2_KYCInfo_minKYC: {
        flexDirection: "column",
        alignItems: "default",
      },
    },
    [maxSize(DEVICE_SIZES.XS)]:
    {
      container: {
        marginLeft: 40,
        height: 655,
      },
      overlayContentStyle: {
        width: "90%",
    },
     
      overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 15,
      },
      KYCUpd: {
        paddingHorizontal: 10,
      },
      KYCUpd_row2: {
        marginTop: 20,
        flexDirection: "column",
      },

      KYCUpd_row2_KYCInfo: {
        width: '100%',
        borderRadius: 15,
        borderWidth: 1,
        borderColor: '#ff6e6e',
        borderStyle: 'solid',
        marginBottom: 10
      },

      KYCUpd_row2_KYCInfo_fullKYC: {
        backgroundImage:
          "linear-gradient(to right, #F8EBEC, #F8EBEC, #fff 94%, rgba(94, 94, 94, 0) 108%)",
        padding: 20,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        justifyContent: "center",
      },

      crownIcon: {
        position: "absolute",
        top: 20,
        right: 20,
        width: 18.3,
        height: 16,
      },

      KYCUpd_row2_KYCInfo_minKYC: {
        padding: 20,
        justifyContent: "center",
      },

      contentTwoStyle:{
        width:"100%",
        marginLeft:0,
        paddingHorizontal:0,
        marginTop:20
      },
    },

  }
);

export default useStyles;
